import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, submitCallback, invalidDataCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      if (fieldName === "codemps") return data?.[fieldName] || [];
      return data?.[fieldName] || "";
    }

    const fieldNames = [
      "module",
      "menu",
      "codemps",
      "sqlFilter",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(() => createInitialData());

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      module: yup.string(),
      menu: yup.string(),
      codemps: yup.array().of(yup.string()),
      sqlFilter: yup.string(),
    })
      .test(
        'module-xor-menu',
        'module and menu are mutually exclusive, and one must be provided',
        ({ module, menu }) => {
          const hasModule = Boolean(module);
          const hasMenu = Boolean(menu);
          return (hasModule || hasMenu) && !(hasModule && hasMenu);
        }
      )
      .test(
        'codemps-xor-sqlFilter',
        'codemps and sqlFilter are mutually exclusive, and one must be provided',
        ({ codemps, sqlFilter }) => {
          const hasCodemps = codemps && codemps.length > 0;
          const hasSqlFilter = Boolean(sqlFilter);
          return (hasCodemps || hasSqlFilter) && !(hasCodemps && hasSqlFilter);
        }
      );

    return await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }


  const submit = async () => {
    if (await dataIsValid()) {
      const dataToSend = { ...formData };
      submitCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    if (fieldName === "module") {
      setFormData({
        ...formData,
        [fieldName]: value,
        menu: "",
      });
      return;
    }

    if (fieldName === "menu") {
      setFormData({
        ...formData,
        [fieldName]: value,
        module: "",
      });
      return;
    }

    if (fieldName === "codemps") {
      setFormData({
        ...formData,
        [fieldName]: value,
        sqlFilter: "",
      });
      return;
    }

    if (fieldName === "sqlFilter") {
      setFormData({
        ...formData,
        [fieldName]: value,
        codemps: [],
      });
      return;
    }

    setFormData({
      ...formData,
      [fieldName]: value,
    });
  }

  return {
    isCreate,
    formData,
    setFormValue,
    submit,
  };
}

export default useHandleForm;